const nonNegativeNumber = (value, fallback) => {
  if (value === "" || value === null || value === undefined) {
    return fallback;
  }

  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : fallback;
};

export function getItemQuantity(item = {}) {
  return nonNegativeNumber(item.amount, 1);
}

export function getItemWeight(item = {}) {
  return nonNegativeNumber(item.weight, 0);
}

export function calculateInventoryWeight(items = []) {
  const total = items.reduce(
    (sum, item) => sum + getItemWeight(item) * getItemQuantity(item),
    0
  );

  return Number(total.toFixed(2));
}
